"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hasAll;
/**
 * Finds if the second array includes all elements from the first array.
 *
 * @param  {Array} firstArr - the first array
 * @param  {Array} secondArr - the second array
 *
 * @return {Boolean} true when at least one element matches, otherwise false.
 */
function hasAll(firstArr, secondArr) {
  if (!Array.isArray(firstArr) || !Array.isArray(secondArr)) {
    return false;
  }
  if (firstArr === true || secondArr === true) {
    return true;
  }
  return secondArr.every(function (element) {
    return firstArr.includes(element);
  });
}